/* ===============================================================================
   CPB SHOW CORRECT PRICE IN CUSTOMIZER FOR ALL CURRENCIES IN INTERNATIONAL MARKET
   =============================================================================== */

(() => {
  const DEBUG = true;

  function log(...args) {
    if (DEBUG) {
      console.log('[CPB Price Fix]', ...args);
    }
  }

  function getCpbState() {
    try {
      return window.CPB
        ?.getStore?.()
        ?.getState?.() ?? null;
    } catch (e) {
      return null;
    }
  }

  function setCpbCurrency() {
    const currency = window.Shopify?.currency?.active;

    if (!currency) {
      setTimeout(setCpbCurrency, 100);
      return;
    }

    document.documentElement.setAttribute(
      'data-cpb-currency',
      currency
    );
  }

  function init() {
    setCpbCurrency();

    const state = getCpbState();

    if (!state) {
      log('Waiting for CPB store...');
      setTimeout(init, 50);
      return;
    }

    const currency = window.Shopify?.currency?.active;
    const rate = Number(window.Shopify?.currency?.rate);

    if (!currency || !rate) {
      log('Waiting for Shopify currency...');
      setTimeout(init, 50);
      return;
    }

    if (currency === 'EUR') {
      log('EUR - skipping');
      return;
    }

    log('Currency:', currency);
    log('Rate:', rate);

    let updating = false;

    function calculatePrice() {
      const currentState = getCpbState();

      if (!currentState?.Product) {
        return null;
      }

      const cpbProduct = currentState.Product;

      const basePrice = Number(
        cpbProduct.base?.price ??
        cpbProduct.price ??
        0
      );

      if (!basePrice) {
        return null;
      }

      const configuredPrice =
        Number(cpbProduct.price ?? basePrice);

      return Math.ceil(
        configuredPrice * rate
      );
    }

    function fixPrice() {
      if (updating) {
        return;
      }

      const correctedPrice = calculatePrice();

      if (!Number.isFinite(correctedPrice)) {
        return;
      }

      const formatted =
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(correctedPrice);

      const elements =
        document.querySelectorAll('.cpb-product-price');

      updating = true;

      elements.forEach(el => {
        const visible =
          el.offsetWidth ||
          el.offsetHeight ||
          el.getClientRects().length;

        if (
          visible &&
          el.textContent.trim() !== formatted
        ) {
          log(
            'Correcting:',
            el.textContent.trim(),
            '→',
            formatted
          );

          el.textContent = formatted;
        }
      });

      updating = false;
    }

    fixPrice();

    setTimeout(fixPrice, 25);
    setTimeout(fixPrice, 50);
    setTimeout(fixPrice, 100);
    setTimeout(fixPrice, 250);
    setTimeout(fixPrice, 500);
    setTimeout(fixPrice, 1000);
    setTimeout(fixPrice, 2000);

    document.addEventListener(
      'CPB_ON_OPTIONS_UPDATE',
      () => {
        setTimeout(fixPrice, 0);
        setTimeout(fixPrice, 25);
        setTimeout(fixPrice, 100);
      }
    );

    const observer =
      new MutationObserver(() => {
        if (!updating) {
          setTimeout(fixPrice, 0);
        }
      });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    log('Active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();